import { Form, Input, Modal } from "antd"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface NewFolderModalProps {
  initialName?: string
  title?: string
  onClose: () => void
  onSubmit: (name: string) => Promise<void>
}

export function NewFolderModal({
  initialName,
  title,
  onClose,
  onSubmit
}: NewFolderModalProps) {
  const { t } = useTranslation()
  const [form] = Form.useForm<{ name: string }>()
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    form.setFieldsValue({ name: initialName || "" })
  }, [initialName, form])

  const handleOk = async () => {
    const values = await form.validateFields().catch(() => null)
    if (!values) return
    setSubmitting(true)
    try {
      await onSubmit(values.name.trim())
      onClose()
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      open
      title={title || t("files.newFolder.title")}
      onCancel={onClose}
      onOk={() => void handleOk()}
      confirmLoading={submitting}
      okText={t("files.newFolder.confirm")}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label={t("files.newFolder.name")}
          rules={[
            {
              required: true,
              message: t("files.newFolder.required")
            }
          ]}
        >
          <Input autoFocus maxLength={255} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
